import { AppContext } from "@/context/AppContextProvider";
import { useContext } from "react";

const useAppContext = () => {
    const values = useContext(AppContext);
    if (!values) {
      throw new Error('App must be wrapped in AppProvider');
    }
    return values;
  };

export default useAppContext